import NavigationTabs from 'components/Navigation/NavigationTabs';
import SectionHeader from 'components/SectionHeader';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {setUrl} from 'utils/request';
import {onApiError} from 'utils/request-axios/utils';

import CustomTemplateForm from '../components/CustomTemplateForm';
import {useCustomTemplateCreate} from '../services';
import {
    CustomTemplateCreateBackendData,
    CustomTemplateCreateFormData,
} from '../types';

const Page = () => {
    const {
        data: {documentType, templateLanguages},
    } = useBackend<CustomTemplateCreateBackendData>();
    const methods = useForm<CustomTemplateCreateFormData>({
        defaultValues: {
            baseTemplateCode: templateLanguages[0].value,
            displayName: '',
            documentTitle: '',
            uploadedFile: null,
            useAdvancedTaxSettings: false,
        },
    });
    const apiCreate = useCustomTemplateCreate(documentType);
    const handleSubmit = async (data: CustomTemplateCreateFormData) => {
        await apiCreate
            .mutateAsync(data)
            .then((result) => {
                setUrl(`/document-template/${result.mid}/edit-from-file/`);
            })
            .catch(onApiError(methods));
    };
    return (
        <div>
            <NavigationTabs.DocumentSettings selection="customTemplates" />
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(handleSubmit)}>
                    <SectionHeader title={t`Create User-Defined Template`} />
                    <CustomTemplateForm />
                </form>
            </FormProvider>
        </div>
    );
};

export default Page;
